// DO NOT EDIT THIS FILE

import gql from 'graphql-tag';

export const COLLAB_UNDER_ORG = gql`
query CollabUnderOrg($search: String) {
  collab: me {
    id
    employee {
      id
      orgPocEmployee: organizationSet(employees_User_FirstName_Icontains: $search) {
        edges {
          node {
            id
            employees(user_FirstName: $search, user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
      # Adding dummey search string to avoid duplicate record while keeping code implementation same
      orgCeoEmployee: organizationSet(employees_User_FirstName_Icontains: "*****") {
        edges {
          node {
            id
            employees(user_FirstName: $search, user_Status_Verified: true) {
              edges {
                node {
                  id
                  user {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
